import React, { FC, memo, ReactNode } from 'react';
import { ReactComponent as TickIcon } from 'assets/icons/tick-circle.svg';
import './styles.scss';

type CardColor = 'red' | 'blue' | 'yellow';

type LoginCardProps = {
  color: CardColor;
  title: string;
  details: string;
  icon: ReactNode;
  isActive: boolean;
};

const LoginCard: FC<LoginCardProps> = ({ color, title, details, icon, isActive }) => {
  return (
    <div className='login-left-card transition-all duration-500'>
      <div
        className={`w-full transition-all duration-500 pl-2 py-2 login-left-card-${
          isActive ? color : 'transparent'
        } flex gap-4 items-center rounded-[20px]`}>
        {icon}
        <div>
          <h4 className='text-base text-gray-5 mb-1'>{title}</h4>
          <p className='text-xs text-gray-4'>{details}</p>
        </div>
        <TickIcon className='tick w-9 mr-4' />
      </div>
    </div>
  );
};

export default memo(LoginCard);
